// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__2iPRo","count":"counter_count__fxBdy","title":"counter_title__vKvHS"};